import { Injectable, EnvironmentInjector, inject, runInInjectionContext } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Recipe } from './recipe.model';

@Injectable({ providedIn: 'root' })
export class RecipeService {
  private injector = inject(EnvironmentInjector);

  constructor(private db: AngularFireDatabase) {}

  private inCtx<T>(fn: () => T): T {
    return runInInjectionContext(this.injector, fn);
  }

  getRecipes(): Observable<Recipe[]> {
    return this.inCtx(() => this.db.list<Recipe>('recipes').snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const val = a.payload.val() as Recipe;
        return {
          id: a.key!,
          ...val,
          feelings: val.feelings || [],
          ingredients: val.ingredients || [],
        };
      }))
    ));
  }

  getRecipeById(id: string): Observable<Recipe | null> {
    return this.inCtx(() => this.db.object<Recipe>(`recipes/${id}`).valueChanges().pipe(
      map(recipe => recipe ? {
        ...recipe,
        id,
        feelings: recipe.feelings || [],
        ingredients: recipe.ingredients || [],
      } : null)
    ));
  }

  addRecipe(recipe: Recipe): Promise<void> {
    return this.inCtx(() => this.db.object(`recipes/${recipe.id}`).set(recipe));
  }

  updateRecipe(recipe: Recipe): Promise<void> {
    return this.inCtx(() => this.db.object(`recipes/${recipe.id}`).set(recipe));
  }

  deleteRecipe(id: string): Promise<void> {
    return this.inCtx(() => this.db.object(`recipes/${id}`).remove());
  }
}
